import React, { useState } from "react";

import style from "css/contact.module.css";
import Inputcontact from "./inputonsite";
import Postcode from "./postcode";
import axios from "axios";
import { openAlert } from "redux/slices/alertSlice";
import { useDispatch } from "react-redux";
import Contactalert from "components/common/contactalert";
import { useMediaQuery } from "react-responsive";

function Freeexperience() {
  const [info, setinfo] = useState({
    manager: "",
    phone: "",
    company: "",
    email: "",
    location: "",
    location_detail: "",
    version: "ko",
    type: "64",
    product: "",
  });
  const [openpost, setopenpost] = useState(false);
  const postchange = (data) => {
    setinfo({ ...info, location: data.address });
    setopenpost(false);
  };

  const clospostpop = () => {
    setopenpost(false);
  };
  const openpostpop = () => {
    setopenpost(true);
  };

  const selectversion = [
    { value: "ko", name: "한글판" },
    { value: "en", name: "영문판" },
  ];
  const selecttype = [
    { value: "64", name: "64bit" },
    { value: "32", name: "32bit" },
  ];
  const selectproduct = [
    { value: "", name: "제품 선택" },
    { value: "ZWCAD2025", name: "ZWCAD2026" },
    { value: "ZDREAM", name: "ZDREAM" },
    { value: "FOXITEDITOR", name: "Foxit PDF Editor" },
  ];

  const setccn = (e) => {
    e = e
      .replace(/[^0-9]/g, "")
      .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
      .replace(/(\-{1,2})$/g, "");
    setinfo({ ...info, phone: e });
  };

  const dispatch = useDispatch();

  const free = () => {
    if (check()) {
      axios
        .post("/open/free", info)
        .then((res) => {
          if (res.status === 200) {
            dispatch(
              openAlert({
                title: "Notice",
                content: "무료체험 요청이 완료되었습니다.",
                submitEventHandler: () =>
                  setinfo({
                    manager: "",
                    phone: "",
                    company: "",
                    email: "",
                    location: "",
                    location_detail: "",
                    version: "ko",
                    type: "64",
                    product: "",
                  }),
              })
            );
          }
        })
        .catch((err) => {
          dispatch(
            openAlert({
              title: "Notice",
              content: err.response.data,
            })
          );
        });
    }
  };

  const check = () => {
    if (info.product === "") {
      dispatch(
        openAlert({
          title: "Notice",
          content: "제품을 선택해주세요.",
          submitEventHandler: () => {},
        })
      );
      return false;
    } else if (info.manager === "") {
      dispatch(
        openAlert({
          title: "Notice",
          content: "신청자를 입력해주세요",
          submitEventHandler: () => {},
        })
      );
      return false;
    } else if (info.phone === "") {
      dispatch(
        openAlert({
          title: "Notice",
          content: "연락처를 입력주세요",
          submitEventHandler: () => {},
        })
      );
      return false;
    } else if (info.company === "") {
      dispatch(
        openAlert({
          title: "Notice",
          content: "회사명을 입력해주세요",
          submitEventHandler: () => {},
        })
      );
      return false;
    } else if (info.location === "") {
      dispatch(
        openAlert({
          title: "Notice",
          content: "주소를 입력해주세요",
          submitEventHandler: () => {},
        })
      );
      return false;
    } else if (info.location_detail === "") {
      dispatch(
        openAlert({
          title: "Notice",
          content: "상세 주소를 입력해주세요.",
          submitEventHandler: () => {},
        })
      );
      return false;
    } else if (info.version === "") {
      dispatch(
        openAlert({
          title: "Notice",
          content: "버전을 선택해주세요.",
          submitEventHandler: () => {},
        })
      );
      return false;
    } else {
      return true;
    }
  };
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  const [opencontect, setopencontect] = useState(false);
  const [contactinfo, setcontactinfo] = useState({
    header: "",
    body: "",
  });
  const closecontectpop = () => {
    setopencontect(false);
  };
  const opencontectpop = () => {
    setopencontect(true);
  };
  const checkline = useMediaQuery({
    query: "(min-width: 1301px)",
  });

  const ismobile = useMediaQuery({
    query: "(max-width: 768px)",
  });
  return (
    <>
      <div className={style.wrapper_h}>
        <div
          className={style.background}
          style={{
            backgroundImage:
              "url('" +
              process.env.REACT_APP_CLIENT_URL +
              "img/contact/free_bg.png')",
          }}
        >
          <div className={style.background_blur}></div>
        </div>
        <div className={style.contact_area}>
          <div className={style.contact_title_wrap}>
            <div className={style.contact_title}>무료체험</div>
            <div className={style.contact_subtitle}>
              Application for free experience
            </div>
            <div className={style.contact_subtitle2}>
              ZWCAD2026 | ZDREAM | Foxit PDF Editor 전용
            </div>
          </div>
        </div>
      </div>
      <div className={style.contact_wrapper}>
        <div className={style.contact_body}>
          <div className={style.contact_contents}>
            <div className={style.contact_contents_title}>
              <p>
                <font>ZWCAD / ZDREAM / ZW3D / Foxit PDF </font> 프로그램을
              </p>
              <p>지금 바로 무료로 체험해보세요.</p>
            </div>
            <div className={style.contact_contents_title2}>
              <p>
                도입 전 실제 업무 환경에서 직접 사용해보시고,{" "}
                {ismobile ? <br /> : ""} 제품의 성능과 호환성을 확인하실 수
                있습니다.
              </p>
              <p>
                간단한 신청서만 작성하시면, {ismobile ? <br /> : ""} 설치파일을
                즉시 다운로드 하실 수 있으며, {ismobile ? <br /> : ""} 전문
                기술지원팀이 설치 밎 활용 방법을 {ismobile ? <br /> : ""} 안내해
                드립니다.
              </p>
            </div>
            <div className={style.contact_contents_info}>
              <div className={style.contact_contents_box_1}>
                <div className={style.contact_contents_box_title}>
                  <font>01</font> 제공 제품
                </div>
                <div className={style.contact_contents_box_body}>
                  <div className={style.contact_contents_box_body_info}>
                    {ismobile ? (
                      ""
                    ) : (
                      <div
                        className={style.contact_contents_box_body_info_dot}
                      />
                    )}
                    <div className={style.contact_contents_box_body_info_title}>
                      {ismobile ? (
                        <div
                          className={style.contact_contents_box_body_info_dot}
                        />
                      ) : (
                        ""
                      )}
                      ZWCAD 2026
                    </div>
                    <div className={style.contact_contents_box_body_info_txt}>
                      : 국산 대체 CAD 솔루션
                    </div>
                  </div>
                  <div className={style.contact_contents_box_body_info}>
                    {ismobile ? (
                      ""
                    ) : (
                      <div
                        className={style.contact_contents_box_body_info_dot}
                      />
                    )}

                    <div className={style.contact_contents_box_body_info_title}>
                      {ismobile ? (
                        <div
                          className={style.contact_contents_box_body_info_dot}
                        />
                      ) : (
                        ""
                      )}{" "}
                      ZDREAM
                    </div>
                    <div className={style.contact_contents_box_body_info_txt}>
                      : 도면 자동화 및 설계 생산성 향상 도구
                      <p>(ZWCAD FULL 버전 기반에서 작동합니다) </p>
                    </div>
                  </div>
                  <div className={style.contact_contents_box_body_info}>
                    {ismobile ? (
                      ""
                    ) : (
                      <div
                        className={style.contact_contents_box_body_info_dot}
                      />
                    )}
                    <div className={style.contact_contents_box_body_info_title}>
                      {ismobile ? (
                        <div
                          className={style.contact_contents_box_body_info_dot}
                        />
                      ) : (
                        ""
                      )}{" "}
                      ZW3D
                    </div>
                    <div className={style.contact_contents_box_body_info_txt}>
                      : 통합 3D CAD/CAM 설계 및 가공 솔루션
                    </div>
                  </div>
                  <div className={style.contact_contents_box_body_info}>
                    {ismobile ? (
                      ""
                    ) : (
                      <div
                        className={style.contact_contents_box_body_info_dot}
                      />
                    )}
                    <div className={style.contact_contents_box_body_info_title}>
                      {ismobile ? (
                        <div
                          className={style.contact_contents_box_body_info_dot}
                        />
                      ) : (
                        ""
                      )}{" "}
                      Foxit PDF Editor
                    </div>
                    <div className={style.contact_contents_box_body_info_txt}>
                      : 가볍고 빠른 PDF 편집 솔루션
                    </div>
                  </div>
                </div>
              </div>
              <div className={style.contact_contents_box}>
                <div className={style.contact_contents_box_title}>
                  <font>02</font> 제공 기간
                </div>
                <div className={style.contact_contents_box_content}>
                  15일 ~ 최대 30일 <p /> 무료 체험 제공
                  <p />
                  <font> (제품별 상이)</font>
                </div>
              </div>
              <div className={style.contact_contents_box}>
                <div className={style.contact_contents_box_title}>
                  <font>03</font> 신청 방법
                </div>
                <div className={style.contact_contents_box_content2}>
                  <p>
                    <font>하단 버튼을 클릭</font>하여
                  </p>
                  <p>
                    <label>신청서를 작성</label>해 주세요.
                  </p>
                  <p>
                    <label>설문 완료 즉시 다운로드 링크가 제공</label>되며,
                  </p>
                  <p> 이후 전문 기술지원팀이 설치 및 </p>
                  <p> 활용을 도와드립니다.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={style.contact_form}>
          <div className={style.contact_form_header}>무료 체험 신청</div>
          <div className={style.contact_form_body}>
            {ismobile ? (
              <div className={style.contact_form_body_wrap}>
                <div className={style.contact_form_body_img}>
                  <img
                    alt=""
                    src={
                      process.env.REACT_APP_CLIENT_URL +
                      "img/support/qrfree_m.png"
                    }
                  />
                  <div>
                    <p>모바일에서도 </p>
                    <p> 바로 접속하려면 </p>
                    <p> 좌측 QR 코드를 스캔하세요.</p>
                  </div>
                </div>
                <div
                  className={style.contact_form_body_txt}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    window.open(
                      "https://form.typeform.com/to/K2z46tsT?typeform-source=qrcode-button",
                      "_blank"
                    )
                  }
                >
                  무료 체험 신청하기
                </div>
              </div>
            ) : (
              <div className={style.contact_form_body_wrap}>
                <div>
                  <img
                    alt=""
                    src={
                      process.env.REACT_APP_CLIENT_URL +
                      "img/support/qrfree.png"
                    }
                  />
                </div>
                <div className={style.contact_form_body_txt}>
                  <div>
                    모바일에서도 바로 접속하려면 좌측 QR 코드를 스캔하세요.
                  </div>
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      window.open(
                        "https://form.typeform.com/to/K2z46tsT?typeform-source=qrcode-button",
                        "_blank"
                      )
                    }
                  >
                    무료 체험 신청하기
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className={style.contact_form_footer}>
            ※ 신청 후 기술지원팀이 추가 안내를 드리며, 본 서비스는 기업 고객을
            위한 체험용입니다. 개인 고객의 경우, 별도 검토 후 개별 안내를 통해
            제공이 가능합니다.
          </div>
        </div>
      </div>
    </>
  );
}

export default Freeexperience;
